export default function(key, imagekey, id) {
  this.selectedProfessions[key].image.splice(imagekey, 1);
  this.selectedProfessions[key].images.splice(imagekey, 1);
  if (!this.selectedProfessions[key].image.length) {
    let ref = "file_" + id;
    this.$refs[ref][0].value = "";
  }
}
